<template>
  <el-table :data="tableData" :span-method="spanMethod" :highlight-current-row="false" border>
    <el-table-column label="歌曲申请ID" prop="trackId" width="90"></el-table-column>

    <el-table-column label="歌曲基础信息" v-slot="{ row }" min-width="180">
      <info-item label="歌曲名" :content="row.trackName"></info-item>
      <info-item label="歌手" :content="row.singerText"></info-item>
      <info-item label="版本" :content="row.srcVersion"></info-item>
    </el-table-column>

    <el-table-column label="专辑信息" v-slot="{ row }" min-width="180">
      <template v-if="row.album">
        <info-item label="专辑名" :content="row.album.albumName"></info-item>
        <info-item label="发行时间" :content="row.album.publicTime"></info-item>
        <info-item label="UPC" :content="row.album.upc"></info-item>
      </template>
      <template v-else>-</template>
    </el-table-column>

    <el-table-column label="歌曲扩展信息" v-slot="{ row }" min-width="180">
      <info-item label="ISRC" :content="row.isrc"></info-item>
      <info-item label="词作者" :content="row.wordAuthorText"></info-item>
      <info-item label="曲作者" :content="row.musicAuthorText"></info-item>
    </el-table-column>

    <el-table-column label="申请状态" prop="status" width="150" v-slot="{ row }">
      <info-item label="状态" :content="conditionMap[row.status]"></info-item>
      <info-item label="当前付费模式" :content="paymentMap[row.trackPayment.paymentMode]"></info-item>
    </el-table-column>

    <el-table-column label="版权类型" v-slot="{ row }">
      {{ authTypeMap[row.authType] }}
    </el-table-column>
    <el-table-column label="版权公司" width="120" prop="companyNameText" show-overflow-tooltip></el-table-column>
    <el-table-column label="授权周期" prop="copyrightDateText" width="180"></el-table-column>
    <template v-if="ixYxCompanyUser">
      <el-table-column label="是否代理" v-slot="{ row }">
        {{ switchMap[row.isAgent] }}
      </el-table-column>
    </template>

    <el-table-column label="操作" v-slot="{ row }" width="80" align="center">
      <online-listen
        class="listen"
        show-text="试听"
        show-icon
        :media="row.media"
        :track-name="row.trackName"
      ></online-listen>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import OnlineListen from '@/components/OnlineListen/index.vue'
import {
  conditionMap,
  isOnlyMap,
  isAgentMap,
  authTypeMap,
  switchMap,
} from '@/utils/constants'
import { paymentMap } from '../../../album/mixin'
import InfoItem from '../InfoItem.vue'

export default {
  name: 'TrackList',

  components: {
    OnlineListen,
    InfoItem,
  },
  props: {
    rawData: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      paymentMap,
      isOnlyMap,
      conditionMap,
      isAgentMap,
      authTypeMap,
      switchMap,

      exportLoading: false
    }
  },

  computed: {
    ...mapGetters([
      'ixYxCompanyUser'
    ]),
    tableData() {
      const trackCpList = []
      for (const trackObj of this.rawData) {
        const { trackCopyright, trackMusicCopyrightList, trackWordCopyrightList, ...trackInfo } = trackObj
        // 处理歌曲字段
        trackInfo.singerText = trackInfo.trackSingerList?.map(v => v.singerName).join('、') ?? ''
        trackInfo.wordAuthorText = trackInfo.trackExtend?.wordAuthor ?? ''
        trackInfo.musicAuthorText = trackInfo.trackExtend?.musicAuthor ?? ''
        trackInfo.trackPayment = trackInfo.trackPayment || {}

        const cpList = []
        if (trackCopyright) {
          cpList.push({
            ...trackCopyright,
            authType: 1,
          })
        }

        if (Array.isArray(trackWordCopyrightList)) {
          trackWordCopyrightList.forEach(cp => {
            cp.authType = 2
            cpList.push(cp)
          })
        }

        if (Array.isArray(trackMusicCopyrightList)) {
          trackMusicCopyrightList.forEach(cp => {
            cp.authType = 3
            cpList.push(cp)
          })
        }

        for (let index = 0; index < cpList.length; index++) {
          const cp = cpList[index]

          // 处理版权字段
          if (cp.copyrightFrom && cp.copyrightTo) {
            cp.copyrightDateText = `${dayjs(cp.copyrightFrom).format('YYYY-MM-DD')} ~ ${dayjs(cp.copyrightTo).format('YYYY-MM-DD')}`
          }

          if (cp.cpCompany && cp.cpCompany.companyName) {
            cp.companyNameText = cp.cpCompany.companyName
          } else {
            cp.companyNameText = '-'
          }

          cp.rowSpan = index === 0 ? cpList.length : 0
          trackCpList.push({ ...trackInfo, ...cp })
        }
      }

      return trackCpList
    },
  },

  methods: {
    spanMethod({ row, columnIndex }) {
      return {
        rowspan: columnIndex < 5 ? row.rowSpan : 1,
        colspan: 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.division {
  display: inline-block;
  width: 2px;
  height: 10px;
  background-color: #ccc;
}

.icon {
  display: inline-block;
  margin-left: 6px;
  vertical-align: sub;
  width: 16px;
  height: 16px;
}

.album-pic {
  background-size: cover;
  background-position: center;
  margin-right: 10px;
  width: 42px;
  height: 42px;
  display: inline-block;
  &.empty {
    background-image: url("~@/assets/default_img.png");
    position: relative;
    &::before {
      font-size: 12px;
      content: '暂无';
      display: block;
      position: absolute;
      line-height: 42px;
      width: 100%;
      color: #fff;
      text-align: center;
    }
  }
}

.track-info {
  width: 105px;
  display: inline-block;
  vertical-align: middle;

  p {
    display: flex;
    align-items: center;
  }
}

.more-message {
  font-size: 12px;
  line-height: 20px;
  .title {
    font-weight: bold;
  }
  p {
    span {
      text-align: right;
      display: inline-block;
      width: 100px;
    }

    &.cp-company {
      margin-bottom: 6px;
    }
  }
}
</style>
